import Vue from 'vue'
import Router from 'vue-router'
import { normalizeURL, decode } from 'ufo'
import { interopDefault } from './utils'
import scrollBehavior from './router.scrollBehavior.js'

const _7be030a0 = () => interopDefault(import('../app/pages/bestbuy/index.vue' /* webpackChunkName: "pages/bestbuy/index" */))
const _0b5babae = () => interopDefault(import('../app/pages/device/index.vue' /* webpackChunkName: "pages/device/index" */))
const _670f775d = () => interopDefault(import('../app/pages/download.vue' /* webpackChunkName: "pages/download" */))
const _be737940 = () => interopDefault(import('../app/pages/expired.vue' /* webpackChunkName: "pages/expired" */))
const _8e2036ac = () => interopDefault(import('../app/pages/firstresponder/index.vue' /* webpackChunkName: "pages/firstresponder/index" */))
const _01cf01d8 = () => interopDefault(import('../app/pages/giftcard/index.vue' /* webpackChunkName: "pages/giftcard/index" */))
const _6d79d532 = () => interopDefault(import('../app/pages/invalid.vue' /* webpackChunkName: "pages/invalid" */))
const _3a275e9f = () => interopDefault(import('../app/pages/logout.vue' /* webpackChunkName: "pages/logout" */))
const _40b4fe65 = () => interopDefault(import('../app/pages/military/index.vue' /* webpackChunkName: "pages/military/index" */))
const _c74a0328 = () => interopDefault(import('../app/pages/netiapl.vue' /* webpackChunkName: "pages/netiapl" */))
const _0cace3ac = () => interopDefault(import('../app/pages/oauth-start/index.vue' /* webpackChunkName: "pages/oauth-start/index" */))
const _4db26ab3 = () => interopDefault(import('../app/pages/onboarding/index.vue' /* webpackChunkName: "pages/onboarding/index" */))
const _711f7faa = () => interopDefault(import('../app/pages/pluspl.vue' /* webpackChunkName: "pages/pluspl" */))
const _9db7a2fe = () => interopDefault(import('../app/pages/preproduct.vue' /* webpackChunkName: "pages/preproduct" */))
const _6278b239 = () => interopDefault(import('../app/pages/products.vue' /* webpackChunkName: "pages/products" */))
const _3113414a = () => interopDefault(import('../app/pages/reset.vue' /* webpackChunkName: "pages/reset" */))
const _0736f3f0 = () => interopDefault(import('../app/pages/signup/index.vue' /* webpackChunkName: "pages/signup/index" */))
const _30a5355f = () => interopDefault(import('../app/pages/store/index.vue' /* webpackChunkName: "pages/store/index" */))
const _51c43979 = () => interopDefault(import('../app/pages/student/index.vue' /* webpackChunkName: "pages/student/index" */))
const _dcc3457e = () => interopDefault(import('../app/pages/success/index.vue' /* webpackChunkName: "pages/success/index" */))
const _7ec5a1bc = () => interopDefault(import('../app/pages/test-deeplink.vue' /* webpackChunkName: "pages/test-deeplink" */))
const _59484da3 = () => interopDefault(import('../app/pages/vivacombg.vue' /* webpackChunkName: "pages/vivacombg" */))
const _568b922c = () => interopDefault(import('../app/pages/voucher/index.vue' /* webpackChunkName: "pages/voucher/index" */))
const _061ae453 = () => interopDefault(import('../app/pages/vt.vue' /* webpackChunkName: "pages/vt" */))
const _3780d9f8 = () => interopDefault(import('../app/pages/account/changepass.vue' /* webpackChunkName: "pages/account/changepass" */))
const _b042dc5e = () => interopDefault(import('../app/pages/bestbuy/success.vue' /* webpackChunkName: "pages/bestbuy/success" */))
const _39305a7b = () => interopDefault(import('../app/pages/debug/data.vue' /* webpackChunkName: "pages/debug/data" */))
const _ea9bb356 = () => interopDefault(import('../app/pages/debug/session.vue' /* webpackChunkName: "pages/debug/session" */))
const _0293d864 = () => interopDefault(import('../app/pages/device/link.vue' /* webpackChunkName: "pages/device/link" */))
const _78622214 = () => interopDefault(import('../app/pages/firstresponder/verify/index.vue' /* webpackChunkName: "pages/firstresponder/verify/index" */))
const _5ddce61a = () => interopDefault(import('../app/pages/giftcard/return.vue' /* webpackChunkName: "pages/giftcard/return" */))
const _6d5df509 = () => interopDefault(import('../app/pages/giftcard/success.vue' /* webpackChunkName: "pages/giftcard/success" */))
const _24e2fb58 = () => interopDefault(import('../app/pages/login/mobileapp.vue' /* webpackChunkName: "pages/login/mobileapp" */))
const _30e526eb = () => interopDefault(import('../app/pages/login/playpl.vue' /* webpackChunkName: "pages/login/playpl" */))
const _7dc60fe4 = () => interopDefault(import('../app/pages/login/reset.vue' /* webpackChunkName: "pages/login/reset" */))
const _89a6ed5c = () => interopDefault(import('../app/pages/login/tidal/index.vue' /* webpackChunkName: "pages/login/tidal/index" */))
const _77daaff9 = () => interopDefault(import('../app/pages/military/verify/index.vue' /* webpackChunkName: "pages/military/verify/index" */))
const _6153e408 = () => interopDefault(import('../app/pages/oauth-start/return.vue' /* webpackChunkName: "pages/oauth-start/return" */))
const _4e0a9324 = () => interopDefault(import('../app/pages/onboarding/success.vue' /* webpackChunkName: "pages/onboarding/success" */))
const _5fe2b9f4 = () => interopDefault(import('../app/pages/sheerid/search.vue' /* webpackChunkName: "pages/sheerid/search" */))
const _885c55a4 = () => interopDefault(import('../app/pages/signup/redirect.vue' /* webpackChunkName: "pages/signup/redirect" */))
const _8edc7dbe = () => interopDefault(import('../app/pages/signup/success.vue' /* webpackChunkName: "pages/signup/success" */))
const _09cd2373 = () => interopDefault(import('../app/pages/store/return.vue' /* webpackChunkName: "pages/store/return" */))
const _2a4ad336 = () => interopDefault(import('../app/pages/student/verify/index.vue' /* webpackChunkName: "pages/student/verify/index" */))
const _7118266b = () => interopDefault(import('../app/pages/v1/health.vue' /* webpackChunkName: "pages/v1/health" */))
const _5603b670 = () => interopDefault(import('../app/pages/voucher/trial.vue' /* webpackChunkName: "pages/voucher/trial" */))
const _3c93553e = () => interopDefault(import('../app/pages/firstresponder/verify/return/index.vue' /* webpackChunkName: "pages/firstresponder/verify/return/index" */))
const _73131d64 = () => interopDefault(import('../app/pages/login/tidal/custom/index.vue' /* webpackChunkName: "pages/login/tidal/custom/index" */))
const _1f9d96f3 = () => interopDefault(import('../app/pages/login/tidal/handover.vue' /* webpackChunkName: "pages/login/tidal/handover" */))
const _59ec68cb = () => interopDefault(import('../app/pages/login/tidal/partner/index.vue' /* webpackChunkName: "pages/login/tidal/partner/index" */))
const _5f9f6440 = () => interopDefault(import('../app/pages/login/tidal/return.vue' /* webpackChunkName: "pages/login/tidal/return" */))
const _053b6848 = () => interopDefault(import('../app/pages/military/verify/return/index.vue' /* webpackChunkName: "pages/military/verify/return/index" */))
const _1ed293f0 = () => interopDefault(import('../app/pages/student/verify/return/index.vue' /* webpackChunkName: "pages/student/verify/return/index" */))
const _14ef60a2 = () => interopDefault(import('../app/pages/subscription-order/login/return.vue' /* webpackChunkName: "pages/subscription-order/login/return" */))
const _151c3c0e = () => interopDefault(import('../app/pages/login/tidal/custom/return.vue' /* webpackChunkName: "pages/login/tidal/custom/return" */))
const _72b72947 = () => interopDefault(import('../app/pages/login/tidal/partner/order.vue' /* webpackChunkName: "pages/login/tidal/partner/order" */))
const _096c5d87 = () => interopDefault(import('../app/pages/login/tidal/partner/return.vue' /* webpackChunkName: "pages/login/tidal/partner/return" */))
const _380fabcd = () => interopDefault(import('../app/pages/login/tidal/partner/vodafone.vue' /* webpackChunkName: "pages/login/tidal/partner/vodafone" */))
const _5732c126 = () => interopDefault(import('../app/pages/sheerid/verification/callback/_requestId.vue' /* webpackChunkName: "pages/sheerid/verification/callback/_requestId" */))
const _7da3e749 = () => interopDefault(import('../app/pages/firstresponder/return/_sessionid.vue' /* webpackChunkName: "pages/firstresponder/return/_sessionid" */))
const _e97d7ef8 = () => interopDefault(import('../app/pages/military/return/_sessionid.vue' /* webpackChunkName: "pages/military/return/_sessionid" */))
const _36580e91 = () => interopDefault(import('../app/pages/partner/plusupsellcallback/_transactionid.vue' /* webpackChunkName: "pages/partner/plusupsellcallback/_transactionid" */))
const _b8e4909e = () => interopDefault(import('../app/pages/playlist/migration/_uuid.vue' /* webpackChunkName: "pages/playlist/migration/_uuid" */))
const _71a0456c = () => interopDefault(import('../app/pages/sheerid/verification/_partnername.vue' /* webpackChunkName: "pages/sheerid/verification/_partnername" */))
const _594c9769 = () => interopDefault(import('../app/pages/sheerid/verify/_verifyid.vue' /* webpackChunkName: "pages/sheerid/verify/_verifyid" */))
const _528c7d98 = () => interopDefault(import('../app/pages/student/return/_sessionid.vue' /* webpackChunkName: "pages/student/return/_sessionid" */))
const _7daae19a = () => interopDefault(import('../app/pages/bestbuy/_code.vue' /* webpackChunkName: "pages/bestbuy/_code" */))
const _28b8637c = () => interopDefault(import('../app/pages/campaigns/_campaignId/index.vue' /* webpackChunkName: "pages/campaigns/_campaignId/index" */))
const _0d265ca8 = () => interopDefault(import('../app/pages/device/_code.vue' /* webpackChunkName: "pages/device/_code" */))
const _28c444d0 = () => interopDefault(import('../app/pages/partner/_orderreference.vue' /* webpackChunkName: "pages/partner/_orderreference" */))
const _6fcd302e = () => interopDefault(import('../app/pages/signup/_partnername/index.vue' /* webpackChunkName: "pages/signup/_partnername/index" */))
const _18a9e8f9 = () => interopDefault(import('../app/pages/subscription-order/_subscriptionOrderId.vue' /* webpackChunkName: "pages/subscription-order/_subscriptionOrderId" */))
const _538700ac = () => interopDefault(import('../app/pages/campaigns/_campaignId/products.vue' /* webpackChunkName: "pages/campaigns/_campaignId/products" */))
const _211ab917 = () => interopDefault(import('../app/pages/signup/_partnername/echo-headers.vue' /* webpackChunkName: "pages/signup/_partnername/echo-headers" */))
const _ef5e5966 = () => interopDefault(import('../app/pages/index.vue' /* webpackChunkName: "pages/index" */))
const _ebc8f772 = () => interopDefault(import('../app/pages/_code.vue' /* webpackChunkName: "pages/_code" */))

const emptyFn = () => {}

Vue.use(Router)

export const routerOptions = {
  mode: 'history',
  base: '/',
  linkActiveClass: 'nuxt-link-active',
  linkExactActiveClass: 'nuxt-link-exact-active',
  scrollBehavior,

  routes: [{
    path: "/bestbuy",
    component: _7be030a0,
    name: "bestbuy"
  }, {
    path: "/device",
    component: _0b5babae,
    name: "device"
  }, {
    path: "/download",
    component: _670f775d,
    name: "download"
  }, {
    path: "/expired",
    component: _be737940,
    name: "expired"
  }, {
    path: "/firstresponder",
    component: _8e2036ac,
    name: "firstresponder"
  }, {
    path: "/giftcard",
    component: _01cf01d8,
    name: "giftcard"
  }, {
    path: "/invalid",
    component: _6d79d532,
    name: "invalid"
  }, {
    path: "/logout",
    component: _3a275e9f,
    name: "logout"
  }, {
    path: "/military",
    component: _40b4fe65,
    name: "military"
  }, {
    path: "/netiapl",
    component: _c74a0328,
    name: "netiapl"
  }, {
    path: "/oauth-start",
    component: _0cace3ac,
    name: "oauth-start"
  }, {
    path: "/onboarding",
    component: _4db26ab3,
    name: "onboarding"
  }, {
    path: "/pluspl",
    component: _711f7faa,
    name: "pluspl"
  }, {
    path: "/preproduct",
    component: _9db7a2fe,
    name: "preproduct"
  }, {
    path: "/products",
    component: _6278b239,
    name: "products"
  }, {
    path: "/reset",
    component: _3113414a,
    name: "reset"
  }, {
    path: "/signup",
    component: _0736f3f0,
    name: "signup"
  }, {
    path: "/store",
    component: _30a5355f,
    name: "store"
  }, {
    path: "/student",
    component: _51c43979,
    name: "student"
  }, {
    path: "/success",
    component: _dcc3457e,
    name: "success"
  }, {
    path: "/test-deeplink",
    component: _7ec5a1bc,
    name: "test-deeplink"
  }, {
    path: "/vivacombg",
    component: _59484da3,
    name: "vivacombg"
  }, {
    path: "/voucher",
    component: _568b922c,
    name: "voucher"
  }, {
    path: "/vt",
    component: _061ae453,
    name: "vt"
  }, {
    path: "/account/changepass",
    component: _3780d9f8,
    name: "account-changepass"
  }, {
    path: "/bestbuy/success",
    component: _b042dc5e,
    name: "bestbuy-success"
  }, {
    path: "/debug/data",
    component: _39305a7b,
    name: "debug-data"
  }, {
    path: "/debug/session",
    component: _ea9bb356,
    name: "debug-session"
  }, {
    path: "/device/link",
    component: _0293d864,
    name: "device-link"
  }, {
    path: "/firstresponder/verify",
    component: _78622214,
    name: "firstresponder-verify"
  }, {
    path: "/giftcard/return",
    component: _5ddce61a,
    name: "giftcard-return"
  }, {
    path: "/giftcard/success",
    component: _6d5df509,
    name: "giftcard-success"
  }, {
    path: "/login/mobileapp",
    component: _24e2fb58,
    name: "login-mobileapp"
  }, {
    path: "/login/playpl",
    component: _30e526eb,
    name: "login-playpl"
  }, {
    path: "/login/reset",
    component: _7dc60fe4,
    name: "login-reset"
  }, {
    path: "/login/tidal",
    component: _89a6ed5c,
    name: "login-tidal"
  }, {
    path: "/military/verify",
    component: _77daaff9,
    name: "military-verify"
  }, {
    path: "/oauth-start/return",
    component: _6153e408,
    name: "oauth-start-return"
  }, {
    path: "/onboarding/success",
    component: _4e0a9324,
    name: "onboarding-success"
  }, {
    path: "/sheerid/search",
    component: _5fe2b9f4,
    name: "sheerid-search"
  }, {
    path: "/signup/redirect",
    component: _885c55a4,
    name: "signup-redirect"
  }, {
    path: "/signup/success",
    component: _8edc7dbe,
    name: "signup-success"
  }, {
    path: "/store/return",
    component: _09cd2373,
    name: "store-return"
  }, {
    path: "/student/verify",
    component: _2a4ad336,
    name: "student-verify"
  }, {
    path: "/v1/health",
    component: _7118266b,
    name: "v1-health"
  }, {
    path: "/voucher/trial",
    component: _5603b670,
    name: "voucher-trial"
  }, {
    path: "/firstresponder/verify/return",
    component: _3c93553e,
    name: "firstresponder-verify-return"
  }, {
    path: "/login/tidal/custom",
    component: _73131d64,
    name: "login-tidal-custom"
  }, {
    path: "/login/tidal/handover",
    component: _1f9d96f3,
    name: "login-tidal-handover"
  }, {
    path: "/login/tidal/partner",
    component: _59ec68cb,
    name: "login-tidal-partner"
  }, {
    path: "/login/tidal/return",
    component: _5f9f6440,
    name: "login-tidal-return"
  }, {
    path: "/military/verify/return",
    component: _053b6848,
    name: "military-verify-return"
  }, {
    path: "/student/verify/return",
    component: _1ed293f0,
    name: "student-verify-return"
  }, {
    path: "/subscription-order/login/return",
    component: _14ef60a2,
    name: "subscription-order-login-return"
  }, {
    path: "/login/tidal/custom/return",
    component: _151c3c0e,
    name: "login-tidal-custom-return"
  }, {
    path: "/login/tidal/partner/order",
    component: _72b72947,
    name: "login-tidal-partner-order"
  }, {
    path: "/login/tidal/partner/return",
    component: _096c5d87,
    name: "login-tidal-partner-return"
  }, {
    path: "/login/tidal/partner/vodafone",
    component: _380fabcd,
    name: "login-tidal-partner-vodafone"
  }, {
    path: "/sheerid/verification/callback/:requestId?",
    component: _5732c126,
    name: "sheerid-verification-callback-requestId"
  }, {
    path: "/firstresponder/return/:sessionid?",
    component: _7da3e749,
    name: "firstresponder-return-sessionid"
  }, {
    path: "/military/return/:sessionid?",
    component: _e97d7ef8,
    name: "military-return-sessionid"
  }, {
    path: "/partner/plusupsellcallback/:transactionid?",
    component: _36580e91,
    name: "partner-plusupsellcallback-transactionid"
  }, {
    path: "/playlist/migration/:uuid?",
    component: _b8e4909e,
    name: "playlist-migration-uuid"
  }, {
    path: "/sheerid/verification/:partnername?",
    component: _71a0456c,
    name: "sheerid-verification-partnername"
  }, {
    path: "/sheerid/verify/:verifyid?",
    component: _594c9769,
    name: "sheerid-verify-verifyid"
  }, {
    path: "/student/return/:sessionid?",
    component: _528c7d98,
    name: "student-return-sessionid"
  }, {
    path: "/bestbuy/:code",
    component: _7daae19a,
    name: "bestbuy-code"
  }, {
    path: "/campaigns/:campaignId",
    component: _28b8637c,
    name: "campaigns-campaignId"
  }, {
    path: "/device/:code",
    component: _0d265ca8,
    name: "device-code"
  }, {
    path: "/partner/:orderreference?",
    component: _28c444d0,
    name: "partner-orderreference"
  }, {
    path: "/signup/:partnername",
    component: _6fcd302e,
    name: "signup-partnername"
  }, {
    path: "/subscription-order/:subscriptionOrderId?",
    component: _18a9e8f9,
    name: "subscription-order-subscriptionOrderId"
  }, {
    path: "/campaigns/:campaignId?/products",
    component: _538700ac,
    name: "campaigns-campaignId-products"
  }, {
    path: "/signup/:partnername/echo-headers",
    component: _211ab917,
    name: "signup-partnername-echo-headers"
  }, {
    path: "/",
    component: _ef5e5966,
    name: "index"
  }, {
    path: "/:code",
    component: _ebc8f772,
    name: "code"
  }],

  fallback: false
}

export function createRouter (ssrContext, config) {
  const base = (config._app && config._app.basePath) || routerOptions.base
  const router = new Router({ ...routerOptions, base  })

  // TODO: remove in Nuxt 3
  const originalPush = router.push
  router.push = function push (location, onComplete = emptyFn, onAbort) {
    return originalPush.call(this, location, onComplete, onAbort)
  }

  const resolve = router.resolve.bind(router)
  router.resolve = (to, current, append) => {
    if (typeof to === 'string') {
      to = normalizeURL(to)
    }
    return resolve(to, current, append)
  }

  return router
}
